module.exports = "/_next/static/videos/CAR-738d3bb068f437a0db7602d934aa3160.mp4";